import {
	API_ALL_TYPES,
	API_CRYPTO_TYPE,
	API_ETC_TYPE,
	API_ETF_TYPE,
	API_INDEX_TYPE,
	API_LEVERAGED_TOKEN_TYPE,
	API_METAL_TYPE,
	API_SECURITY_TYPE,
	API_STOCK_TYPE,
	CRYPTO_TYPE,
	ETC_TYPE,
	ETF_TYPE,
	INDEX_TYPE,
	LEVERAGED_TOKEN_TYPE,
	METAL_TYPE,
	STOCK_TYPE,
	TRADABLES_TYPE
} from "@helpers/constants";
import { BpOption } from "@models/ui-components/bp-option";
import { Dictionary } from "@helpers/types";
import { TIMESPAN_OHLC_FILTERED_OPTIONS } from "@helpers/const/timespan";
export const CURRENCY_FILTER_HIGHLIGHTS = "currency_filter_highlights";

//currency filters for PRICES PAGE
export const PRICE_PAGE_LIST_FILTERS: BpOption[] = [
	{ label: CURRENCY_FILTER_HIGHLIGHTS, value: "" },
	{ label: "currency_filter_view_all", value: API_ALL_TYPES },
	{ label: "search_crypto", value: API_CRYPTO_TYPE },
	{ label: "currency_filter_leveraged_tokens", value: API_LEVERAGED_TOKEN_TYPE },
	{ label: "currency_filter_crypto_indices", value: API_INDEX_TYPE },
	{ label: "currency_filter_security", value: API_SECURITY_TYPE },
	{ label: "currency_filter_stocks", value: API_STOCK_TYPE },
	{ label: "currency_filter_etfs", value: API_ETF_TYPE },
	{ label: "currency_filter_etcs", value: API_ETC_TYPE },
	{ label: "currency_filter_metals", value: API_METAL_TYPE }
];

//currency filters for BUY && SAVINGS PLAN
export const ASSET_LIST_FILTERS: BpOption[] = [
	{ label: "currency_filter_view_all", value: "" },
	{ label: "search_crypto", value: API_CRYPTO_TYPE },
	{ label: "currency_filter_leveraged_tokens", value: API_LEVERAGED_TOKEN_TYPE },
	{ label: "currency_filter_crypto_indices", value: API_INDEX_TYPE },
	{ label: "currency_filter_security", value: API_SECURITY_TYPE },
	{ label: "currency_filter_stocks", value: API_STOCK_TYPE },
	{ label: "currency_filter_etfs", value: API_ETF_TYPE },
	{ label: "currency_filter_etcs", value: API_ETC_TYPE },
	{ label: "currency_filter_metals", value: API_METAL_TYPE }
];

//currency filters for SELL
export const ASSET_LIST_CURRENCY_TYPE_FILTERS: BpOption[] = [
	{ label: "currency_filter_view_all", value: "" },
	{ label: "search_crypto", value: CRYPTO_TYPE },
	{ label: "currency_filter_leveraged_tokens", value: LEVERAGED_TOKEN_TYPE },
	{ label: "currency_filter_crypto_indices", value: INDEX_TYPE },
	{ label: "currency_filter_security", value: TRADABLES_TYPE.SECURITY_TOKEN },
	{ label: "currency_filter_stocks", value: STOCK_TYPE },
	{ label: "currency_filter_etfs", value: ETF_TYPE },
	{ label: "currency_filter_etcs", value: ETC_TYPE },
	{ label: "currency_filter_metals", value: METAL_TYPE }
];

let headlines: Dictionary<string> = {
	"": "all_assets"
};
headlines[API_CRYPTO_TYPE] = "all_cryptocurrencies";
headlines[API_INDEX_TYPE] = "all_indices";
headlines[API_STOCK_TYPE] = "all_stocks";
headlines[API_ETF_TYPE] = "all_etfs";
headlines[API_ETC_TYPE] = "all_etcs";
headlines[API_LEVERAGED_TOKEN_TYPE] = "all_leveraged_tokens";
headlines[API_METAL_TYPE] = "all_metals";
headlines[API_SECURITY_TYPE] = "all_security_tokens";

export const ASSET_LIST_HEADLINES: Dictionary<string> = headlines;

export const ASSET_LIST_TIMEFRAMES = TIMESPAN_OHLC_FILTERED_OPTIONS;

export const LIMIT_ORDER_FIAT_PRECISION = 2;

export const SAVINGS_VISION_BENEFIT_FEE_COOKIE = "savings-vision-benefit-fee";
export const SAVINGS_ELIGIBLE_VISION_BENEFIT_FEE_COOKIE = "savings-eligible-vision-benefit-fee";
